<template>
    <div
        :class="[{ open: show }]"
    >
        <button
            @click="toggle"
            class="
                toggle
                d-flex
                align-items-center
                justify-content-between
                w-100
                py-4
                py-lg-5
                border-info
            "
        >
            <div class="row ml-3">
                <ui-icon
                    icon="arrow-down"
                    class="toggle-icon"
                />

                <div class="accordion-header">
                    <slot name="header" />
                </div>
            </div>
        </button>
        <div
            v-show="show"
            class="pb-4 pb-lg-5"
        >
            <transition name="fade">
                <slot />
            </transition>
        </div>
    </div>
</template>

<script>
import UiIcon from './icon.vue';

export default {
    name: 'UiAccordion',
    components: {
        UiIcon,
    },
    props: {
        open: {
            type: Boolean,
            default: true,
        },
        save: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            pathKey: '',
            show: true,
        };
    },
    mounted() {
        this.pathKey = `Accordion-${window.location.pathname}`;

        if (this.save && JSON.parse(localStorage.getItem(this.pathKey))) {
            this.show = JSON.parse(localStorage.getItem(this.pathKey)).includes(this.uniqueId);
        }

        if (!this.save) {
            this.show = this.open;
        }
    },
    computed: {
        uniqueId() {
            return this._uid;
        },
    },
    methods: {
        toggle() {
            if (!this.save) {
                this.show = !this.show;

                return;
            }

            let currentData = JSON.parse(localStorage.getItem(this.pathKey)) || [];

            if (currentData) {
                const idExsists = currentData.includes(this.uniqueId);

                idExsists
                    ? currentData = currentData.filter(id => id !== this.uniqueId)
                    : currentData.push(this.uniqueId);

                localStorage.setItem(this.pathKey, JSON.stringify(currentData));
            }

            this.show = !this.show;
        },
    },
    watch: {
        open() {
            this.show = this.open;
        },
    }
}
</script>

<style lang="scss" scoped>
    .toggle {
        font-size: rem(32px);

        &-icon {
            transition: 0.3s;
            transform: scaleY(-1);

            .open & {
                transform: scaleY(1);
            }
        }
    }
</style>
